import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ loading, progress }) => {
  if (!loading) return null;

  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        >
        </div>
      </div>
      <div className="progress-text">{Math.floor(progress)}%</div>
    </div>
  );
};

export default ProgressBar;
